import React from 'react';
import { Link } from 'react-router-dom';

/**
 * Inline banner shown when a user hits a plan limit or tries to access a
 * feature not in their current tier.
 *
 * Props:
 *   title    — short headline (default: "Upgrade your plan")
 *   message  — body text explaining the limitation
 *   cta      — button label (default: "See plans")
 *   to       — Link destination (default: "/billing")
 */
export default function UpgradeBanner({ title, message, cta, to }) {
  return (
    <div style={{
      background: 'linear-gradient(135deg, #eff6ff 0%, #f0fdf4 100%)',
      border: '1px solid #bfdbfe',
      borderRadius: 12,
      padding: '20px 24px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: 20,
      marginBottom: 20,
      flexWrap: 'wrap',
    }}>
      <div>
        <div style={{ fontSize: 15, fontWeight: 600, color: '#1e40af', marginBottom: 4 }}>
          {title || 'Upgrade your plan'}
        </div>
        {message && (
          <div style={{ fontSize: 13, color: '#374151', lineHeight: 1.5 }}>{message}</div>
        )}
      </div>
      <Link
        to={to || '/billing'}
        style={{
          display: 'inline-block',
          background: '#1e40af', color: '#fff',
          fontWeight: 600, fontSize: 13,
          padding: '9px 20px', borderRadius: 8,
          textDecoration: 'none', whiteSpace: 'nowrap', flexShrink: 0,
        }}
      >
        {cta || 'See plans'}
      </Link>
    </div>
  );
}
